import { render, staticRenderFns } from "./PortfolioHistory.vue?vue&type=template&id=2f8dcd89&scoped=true&"
import script from "./PortfolioHistory.vue?vue&type=script&lang=js&"
export * from "./PortfolioHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8dcd89",
  null
  
)

export default component.exports